import { render, staticRenderFns } from "./dailymenuitems.vue?vue&type=template&id=6125f19e&scoped=true"
import script from "./dailymenuitems.vue?vue&type=script&lang=js"
export * from "./dailymenuitems.vue?vue&type=script&lang=js"
import style0 from "./dailymenuitems.vue?vue&type=style&index=0&id=6125f19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125f19e",
  null
  
)

export default component.exports